import React from "react";
import AddProductTable from "./AddProductTable";

const AddProductList = () => {
  return (
    <div className="bg-white rounded-lg shadow w-full h-full overflow-auto p-4">
      <AddProductTable />
    </div>
  );
};

export default AddProductList;